export default __webpack_public_path__ + "static/media/bg-1.cef1c0fa.jpg";